import React, { useState } from "react";
import {
  Box,
  Typography,
  Button,
  Grid,
  Card,
  CardContent,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TextField,
} from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";

const FieldDash = () => {
  const [selectedDate, setSelectedDate] = useState("");

  const data = [
    { name: "Alwyn Pereira", totalDistance: "-", totalTime: "-", timeInMotion: "-", timeAtRest: "-" },
    { name: "Arun V Nath", totalDistance: "-", totalTime: "-", timeInMotion: "-", timeAtRest: "-" },
    { name: "Ashish Kumar", totalDistance: "-", totalTime: "-", timeInMotion: "-", timeAtRest: "-" },
    { name: "Bharath Kumar", totalDistance: "-", totalTime: "-", timeInMotion: "-", timeAtRest: "-" },
    { name: "Chandru V", totalDistance: "4.5 kms", totalTime: "1 hour 16 mins", timeInMotion: "15 mins", timeAtRest: "1 hour 1 min" },
    { name: "Charan Gowda", totalDistance: "-", totalTime: "-", timeInMotion: "-", timeAtRest: "-" },
    { name: "Charles", totalDistance: "-", totalTime: "-", timeInMotion: "-", timeAtRest: "-" },
    { name: "Gookul Raj", totalDistance: "-", totalTime: "-", timeInMotion: "-", timeAtRest: "-" },
  ];

  return (
    <Box sx={{ p: 3, backgroundColor: "#f8f9fa" }}>
      {/* Title */}
      <Typography variant="h5" sx={{ mb: 3, fontWeight: "bold", color: "#333" }}>
        Dashboard
      </Typography>

      {/* Date Picker and Download Button */}
      <Box sx={{ display: "flex", justifyContent: "space-between", mb: 3, alignItems: "center" }}>
        <TextField
          label="Date"
          type="date"
          value={selectedDate}
          onChange={(e) => setSelectedDate(e.target.value)}
          sx={{
            width: "200px",
            backgroundColor: "white",
            borderRadius: "5px",
            "& .MuiOutlinedInput-root": {
              border: "1px solid gray",
              "&:hover fieldset": { borderColor: "black" },
              "&.Mui-focused fieldset": { borderColor: "black" },
            },
            "& .MuiInputBase-input": {
              color: "black",
            },
            "& .MuiInputLabel-root": {
              color: "black",
            },
          }}
          InputLabelProps={{ shrink: true }}
        />
        <Button
          variant="contained"
          color="primary"
          startIcon={<DownloadIcon />}
          sx={{
            backgroundColor: "#2196f3",
            "&:hover": { backgroundColor: "#1976d2" },
          }}
        >
          Download Report
        </Button>
      </Box>

      {/* Info Boxes */}
      <Grid container spacing={2} mb={3}>
        {[
          { title: "Total Distance", value: "38.7 kms", color: "#e8f5e9" },
          { title: "Total Time", value: "19 hrs 44 mins", color: "#f3e5f5" },
          { title: "Total Time\nSpent in Motion", value: "1 hour 44 mins", color: "#e3f2fd" },
          { title: "Total Time\nSpent in Rest", value: "17 hrs 59 mins", color: "#e8eaf6" },
        ].map((box, index) => (
          <Grid item xs={12} sm={6} md={3} key={index}>
            <Card sx={{ backgroundColor: box.color }}>
              <CardContent>
                <Typography variant="subtitle2" sx={{ fontWeight: "bold", color: "#333" }}>
                  {box.title}
                </Typography>
                <Typography variant="h6" sx={{ fontWeight: "bold", color: "#333" }}>
                  {box.value}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>

      {/* Data Table */}
      <TableContainer component={Paper} sx={{ backgroundColor: "white" }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell sx={{ fontWeight: "bold", color: "black" }}>Name</TableCell>
              <TableCell sx={{ fontWeight: "bold", color: "black" }}>Total Distance</TableCell>
              <TableCell sx={{ fontWeight: "bold", color: "black" }}>Total Time</TableCell>
              <TableCell sx={{ fontWeight: "bold", color: "black" }}>Total Time in Motion</TableCell>
              <TableCell sx={{ fontWeight: "bold", color: "black" }}>Total Time at Rest</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data.map((row, index) => (
              <TableRow key={index}>
                <TableCell sx={{ color: "black" }}>{row.name}</TableCell>
                <TableCell sx={{ color: "black" }}>{row.totalDistance}</TableCell>
                <TableCell sx={{ color: "black" }}>{row.totalTime}</TableCell>
                <TableCell sx={{ color: "black" }}>{row.timeInMotion}</TableCell>
                <TableCell sx={{ color: "black" }}>{row.timeAtRest}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default FieldDash;
